<script>
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { generateUUID } from '@common/utils/strings';

  export let metric = null;
  export let value = null;
  export let change = null;
  export let tooltip = null;

  const id = generateUUID();
</script>

<div class="kpi">
  <div class="metric">
    {metric}

    {#if tooltip}
      <Icon name="help-circle" id="tooltip-{id}" class="cursor-help" />
      <Tooltip target="tooltip-{id}" placement="top">
        {@html tooltip}
      </Tooltip>
    {/if}
  </div>
  <div class="value">
    {value}
    {#if change && change.value !== '0%'}
      <small class="change {change.type}">
        {#if change.value === '0%'}
          <span />
        {:else}
          <span>{parseFloat(change.value).toLocaleString()}%</span>
        {/if}
        {#if change.type === 'positive'}
          <Icon name="trending-up" />
        {/if}
        {#if change.type === 'negative'}
          <Icon name="trending-down" />
        {/if}
      </small>
    {/if}
  </div>
</div>

<style lang="scss" src="./kpi.scss"></style>
